import React, { useContext, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { SelectValuesContext } from "../../Context/SelectValuesContext";
import { Add, Remove, Clear } from "@mui/icons-material";
import { Division } from "../Icons";
import FunctionSelectorModal from "./FunctionSelectorModal";
import { evaluateExpression } from "./calculatorUtils";
import renderButton from "./renderButton";

const Calculator = () => {
  const { selectValues, setSelectValues } = useContext(SelectValuesContext);

  const [display, setDisplay] = useState("");
  const [result, setResult] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const updateCalculateValue = (value) => {
    setSelectValues((prev) =>
      prev.map((item) =>
        item.name === "CalculateValue" ? { ...item, value } : item
      )
    );
  };

  const handleButtonClick = (value) => {
    if (value === "=") {
      try {
        const evalResult = evaluateExpression(display);
        setResult(evalResult);
        updateCalculateValue(evalResult);
      } catch {
        setResult("Error");
      }
    } else if (value === "C") {
      setDisplay("");
      setResult(null);
    } else if (value === "(") {
      setDisplay(display + ")");
    } else if (value === ")") {
      setDisplay(display + "(");
    } else if (value === "Function") {
      setModalOpen(true);
    } else {
      setDisplay(display + value);
    }
  };

  const handleFunctionSelect = (func) => {
    setDisplay(display + `${func}(`);
    setModalOpen(false);
  };

  const buttons = [
    "(", ")", "C", "/",
    "7", "8", "9", "*",
    "4", "5", "6", "-",
    "1", "2", "3", "+",
    "0", ".", "=", "Function", ","
  ];

  return (
    <Grid container spacing={2} mt={3}>
      <Grid item xs={12} md={7}>
        <Box p={2} sx={{ background: "#f3f3fe", borderRadius: 1 , height:'100%' }}>
          <Typography variant="h5" align="right">{display}</Typography>
          {result !== null && (
            <Typography variant="h6" align="right" color="textSecondary">
              = {result}
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={5}>
        <Grid container spacing={1} justifyContent="center">
          {buttons.map((btn) =>
            renderButton(btn, handleButtonClick)
          )}
        </Grid>
      </Grid>

      <FunctionSelectorModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        onSelect={handleFunctionSelect}
      />
    </Grid>
  );
};

export default Calculator;
